<script setup lang="ts">

import { FilterDateRange } from '@shared/ui/filters'
import { AppSelect } from '@shared/ui/selects'

import { useFilterDatePreset } from '../../model/filter-date-preset.hook'

defineOptions({
  name: 'FilterDatePreset',
})

const {
  preset,
  customRange,
  isCustom,
  presetOptions,
} = useFilterDatePreset()
</script>

<template>
  <div class="filter-date-preset">
    <AppSelect
      v-model="preset"
      class="filter-date-preset__select"
      :options="presetOptions"
      label="Change date"
      placeholder="Any time"
      clearable
    />

    <FilterDateRange
      v-if="isCustom"
      v-model="customRange"
      :presets="false"
      :enable-time-picker="false"
      :partial-range="false"
      input-format="yyyy-MM-dd"
    />
  </div>
</template>

<style scoped lang="scss" src="./FilterDatePreset.scss" />
